import { ChainlitAPI, ChainlitContext } from '@chainlit/react-client'
import { PropsWithChildren, useMemo } from 'react'

import { getAppBaseUrl } from '@/utils/origin'

export const ChainlitProvider = ({ children }: PropsWithChildren) => {
	const baseUrl = `${getAppBaseUrl()}/chainlit`
	const apiClient = useMemo(() => new ChainlitAPI(baseUrl, 'webapp'), [baseUrl])
	return (
		<ChainlitContext.Provider value={apiClient}>
			{children}
		</ChainlitContext.Provider>
	)
}
